export default ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="46"
    height="55"
    viewBox="0 0 46 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.7508 50.8824H7.42996C5.55937 50.8824 4.03952 49.3625 4.03952 47.4919V7.50809C4.03952 5.6375 5.55937 4.11765 7.42996 4.11765H34.9432C36.8138 4.11765 38.3336 5.6375 38.3336 7.50809V24.6707C38.3336 25.5281 39.0351 26.2296 39.8925 26.2296C40.7498 26.2296 41.4513 25.5281 41.4513 24.6707V7.50809C41.4513 3.92279 38.5285 1 34.9432 1H7.42996C3.84467 1 0.921875 3.92279 0.921875 7.50809V47.4919C0.921875 51.0772 3.84467 54 7.42996 54H23.7508C24.6082 54 25.3097 53.2985 25.3097 52.4412C25.3097 51.5838 24.616 50.8824 23.7508 50.8824Z"
      fill="#D8E4FF"
      stroke="#D8E4FF"
      strokeWidth="0.5"
    />
    <path
      d="M40.3344 44.4441C41.4957 42.8385 42.1816 40.8822 42.1816 38.7544C42.1816 33.3842 37.8091 29.0117 32.4389 29.0117C27.0688 29.0117 22.6963 33.3842 22.6963 38.7544C22.6963 44.1245 27.0688 48.497 32.4389 48.497C34.5667 48.497 36.5231 47.8033 38.1286 46.6498L42.1972 50.7183C42.5011 51.0223 42.8986 51.1782 43.2961 51.1782C43.6936 51.1782 44.0911 51.0223 44.3951 50.7183C45.003 50.1104 45.003 49.1205 44.3951 48.5126L40.3344 44.4441ZM25.8139 38.7544C25.8139 35.0989 28.7835 32.1294 32.4389 32.1294C36.0944 32.1294 39.0639 35.0989 39.0639 38.7544C39.0639 42.4098 36.0944 45.3794 32.4389 45.3794C28.7835 45.3794 25.8139 42.4098 25.8139 38.7544Z"
      fill="#D8E4FF"
      stroke="#D8E4FF"
      strokeWidth="0.5"
    />
    <path
      d="M30.2026 14.2737C30.2026 13.4163 29.5011 12.7148 28.6437 12.7148H13.718C12.8607 12.7148 12.1592 13.4163 12.1592 14.2737C12.1592 15.131 12.8607 15.8325 13.718 15.8325H28.6515C29.5089 15.8325 30.2026 15.1388 30.2026 14.2737Z"
      fill="#D8E4FF"
      stroke="#D8E4FF"
      strokeWidth="0.5"
    />
    <path
      d="M13.718 22.5156C12.8607 22.5156 12.1592 23.2171 12.1592 24.0744C12.1592 24.9318 12.8607 25.6333 13.718 25.6333H21.1848C22.0421 25.6333 22.7436 24.9318 22.7436 24.0744C22.7436 23.2171 22.0421 22.5156 21.1848 22.5156H13.718Z"
      fill="#D8E4FF"
      stroke="#D8E4FF"
      strokeWidth="0.5"
    />
  </svg>
);
